import React from 'react'
import { Typography } from 'antd';

const { Title } = Typography;

const PageHeading = ({name, icon}) => {
  return (
    <div style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "30px"
    }}>
        <div style={{
            backgroundColor: "#696cff",
            width: "40px",
            height: "40px",
            borderRadius: "5px",
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "10px",
            color: "#fff", 
            fontSize: "20px"
        }}>
            { icon }
        </div>
        <Title level={4} style={{marginTop: "10px"}}>{ name }</Title>
    </div>
  );
}

export default PageHeading